// src/components/Callback.jsx
import React, { useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Callback = () => {
  const navigate = useNavigate();
  const backendUrl =
    process.env.REACT_APP_BACKEND_URL ||
    (process.env.NODE_ENV === "production"
      ? "https://finance.dev.marsforce.in"
      : "http://localhost:8030");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const sessionState = params.get("session_state");
    const error = params.get("error");
    const errorDesc = params.get("error_description");

    // Handle Microsoft error
    if (error) {
      const msg = encodeURIComponent(errorDesc || error);
      navigate(`/?auth_error=${msg}`, { replace: true });
      return;
    }

    // Missing code
    if (!code) {
      navigate(
        `/?auth_error=${encodeURIComponent(
          "Login failed: No authorization code"
        )}`,
        {
          replace: true,
        }
      );
      return;
    }

    // Send to backend
    axios
      .post(
        `${backendUrl}/auth/token`,
        { code, session_state: sessionState },
        { withCredentials: true } // Important for session
      )
      .then((res) => {
        const data = res.data;

        if (!data.success || !data.user || !data.accessToken) {
          throw new Error("Invalid response from server");
        }

        // SAVE EVERYTHING NEEDED
        localStorage.setItem("userId", data.user.userId);
        localStorage.setItem("userName", data.user.name);
        localStorage.setItem("userEmail", data.user.email);
        localStorage.setItem("accessToken", data.accessToken);
        localStorage.setItem("profile", JSON.stringify(data.user)); // Stringified!

        console.log("Login successful! Redirecting to dashboard...");

        // FINAL REDIRECT
        navigate("/dashboard", { replace: true });
      })
      .catch((err) => {
        console.error("Token exchange failed:", err);
        const msg =
          err.response?.data?.error ||
          err.response?.data?.details ||
          err.message ||
          "Login failed";
        navigate(`/?auth_error=${encodeURIComponent(msg)}`, { replace: true });
      });
  }, [navigate, backendUrl]);

  return (
    <div
      className="landing-container"
      style={{ textAlign: "center", paddingTop: "4rem", fontSize: "18px" }}
    >
      <p>Processing login… Please wait</p>
    </div>
  );
};

export default Callback;
